<template>
  <div v-if="expired">
    Your invitation link that you has expired. Please request a new one via the contact
    form on the Fleet Risk Review site.
  </div>
  <div v-else>
    <div class="bg-brand-taupe-500">
      <PageHeader :headingContent="headingContent" />
      <div class="pb-20 px-4">
        <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
          <div class="px-4 gap-4">
            <p class="mb-4">
              Welcome to Fleet Risk Review. <br /><br />Thank you for accepting our
              invitation to complete a review. To complete your account details please
              complete the fields below and we'll log you in and you'll be able to create
              your first review.<br /><br />
              Please use the email address to which this invitation was sent in order to
              login to Fleet Risk Review in the future.
            </p>
            <p class="mb-4">
             Passwords must be at least <strong>8 characters and contain at least one uppercase character, one number and one special character</strong>
            </p>
          </div>
          <form class="px-4 flex flex-wrap gap-4" @submit.prevent autocomplete="off">
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="name" class="font-semibold text-brand-blue-400"
                  >Full Name</label
                >
              </div>
              <div class="w-3/4">
                <input
                  class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                  id="name"
                  type="text"
                  v-model="form.name"
                  autocomplete="off"
                />
              </div>
              <div
                v-if="$attrs.errors.name"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
              >
                {{ $attrs.errors.name }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="password" class="font-semibold text-brand-blue-400"
                  >Password</label
                >
              </div>
              <div class="w-3/4">
                <input
                  class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                  id="password"
                  type="password"
                  v-model="form.password"
                  autocomplete="off"
                />
              </div>
              <div
                v-if="$attrs.errors.password"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
              >
                {{ $attrs.errors.password }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="password" class="font-semibold text-brand-blue-400"
                  >Confirm Password</label
                >
              </div>
              <div class="w-3/4">
                <input
                  class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                  id="password"
                  type="password"
                  v-model="form.password_confirmation"
                  autocomplete="off"
                />
              </div>
              <div
                v-if="$attrs.errors.password_confirmation"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
              >
                {{ $attrs.errors.password_confirmation }}
              </div>
            </div>
            <div class="flex justify-end w-full">
              <button
                class="bg-brand-green-400 hover:bg-brand-green-200 text-white font-bold py-2 px-4 mr-2 rounded uppercase"
                @click="
                  form.post(
                    route('invitations.accept', {
                      expires: expires,
                      invitation: invitationId,
                      signature: signature,
                    }),
                    {
                      preserveScroll: true,
                      preserveState: true,
                    }
                  )
                "
              >
                Create Account
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import { ref } from "vue";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  components: {
    PageHeader,
  },
  name: "AcceptInvitation",
  setup() {
    let url = new URL(window.location.href);
    const expires = url.searchParams.get("expires");
    const expired = (Date.now() / 1000).toFixed(0) > expires;
    const invitationId = url.pathname.substring(url.pathname.lastIndexOf("/") + 1);
    const signature = url.searchParams.get("signature");
    const form = useForm({
      expires,
      name: "",
      password: "",
      password_confirmation: "",
      signature,
    });
    const headingContent = {
      hero: {
        image: "/images/254411986_car_hero.jpg",
        title: "Fleet Risk Review",
        subtitle: "In association with AXA Insurance",
      },
      page: {
        title: "Account Details",
        subtitle: "",
      },
    };
    return {
      expired,
      expires,
      form,
      invitationId,
      signature,
      headingContent,
    };
  },
};
</script>

<style scoped></style>
